module.exports = __webpack_public_path__ + "static/media/ias.ca4c3995.svg";